import { Component, Input } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { ReviewService } from 'src/app/services/common/review.service';

@Component({
  selector: 'app-budget-reassignment-view-modal',
  templateUrl: './budget-reassignment-view-modal.component.html',
  styleUrl: './budget-reassignment-view-modal.component.scss'
})
export class BudgetReassignmentViewModalComponent {
  @Input() public Content: any;
  rowData: any[] = [];
  currentBudgetID: string;
  budgetTypeOptions = [
    { label: 'Select', value: null },
    { label: 'Budget Surplus', value: 1 },
    { label: 'Budget Deficit', value: 2 }
  ];
  budgetReAssignmentForm!: UntypedFormGroup;

  selectedBudgetType: number | null = null;
  carryForwardBudgets: { label: string; value: any }[] = [];
  reallocationBudgets: { label: string; value: any }[] = [];
  allBudgetsRaw: any;

  constructor(private modalService: NgbModal, public modalRef: NgbActiveModal,
    private fb: UntypedFormBuilder, private commonService: CommonService, private budgetReassignmentService: ReviewService,) { }

  ngOnInit() {

    this.budgetReAssignmentForm = this.fb.group({
      budgetName: [{ value: '', disabled: true }],
      year: [{ value: '', disabled: true }],
      budgetType: [null, Validators.required],
      amount: ['', Validators.required],
      targetBudgetId: [null],
      unusedAmount: [{ value: '', disabled: true }],
    });

    this.currentBudgetID = this.Content.data.ID;
    this.budgetReAssignmentForm.patchValue({
      budgetName: this.Content.data.BUDGET_NAME || '',
      year: this.Content.data.TIMELINE_VALUEStr || ''
    });

    // Load current budget ReassignmentHistory
    this.loadBudgetReassignmentHistory();
  }

  private loadAllBudgetExcludingCurrent(): void {
    if (!this.currentBudgetID || !this.selectedBudgetType) return;

    const actionType = this.selectedBudgetType === 1 ? 'surplus' : 'deficit';

    this.budgetReassignmentService.EditReview(
      `api/BudgetAssignment/GetBudgetsExcludingCurrent?currentBudgetId=${this.currentBudgetID}&ModuleId=${this.Content.ModuleId}&actionType=${actionType}`
    ).subscribe({
      next: (res: any) => {
        if (res?.Status === 0 && res?.Data) {
          this.allBudgetsRaw = res.Data.Budgets;

          if (this.selectedBudgetType === 1) {
            const autoAmount = res.Data.CurrentBudgetRemaining ?? 0;
            this.budgetReAssignmentForm.controls['unusedAmount'].setValue(autoAmount);
            this.budgetReAssignmentForm.get('unusedAmount')?.disable();
          } else {
            this.budgetReAssignmentForm.get('amount')?.enable();
          }

          const dropdownOptions = res.Data.Budgets.map((b: any) => {
            const isSurplus = this.selectedBudgetType === 1;
            const eligible =
              isSurplus
                ? [1, 2, 3].includes(b.BUDGET_STATUS)
                : b.BUDGET_STATUS !== 4 || b.ACTUAL_REMAINING_BUDGET > 0;

            return {
              label: `${b.BUDGET_NAME} (${this.getStatusLabel(b.BUDGET_STATUS)})`,
              value: b.ID,
              unusedAmount: b.ACTUAL_REMAINING_BUDGET ?? 0,
              disabled: !eligible,
              title: !eligible
                ? (b.BUDGET_STATUS === 4 ? 'Closed budget has no unused amount' : 'Not eligible for reassignment')
                : ''
            };
          });

          if (this.selectedBudgetType === 1) {
            this.carryForwardBudgets = dropdownOptions;
          } else {
            this.reallocationBudgets = dropdownOptions;
          }
        }
      },
      error: err => {
        console.error('Error loading budget data:', err);
      }
    });
  }

  private getStatusLabel(status: number): string {
    switch (status) {
      case 1: return 'Inactive';
      case 2: return 'Active';
      case 3: return 'On-hold';
      case 4: return 'Closed';
      default: return 'Unknown';
    }
  }


  private loadBudgetReassignmentHistory(): void {
    if (!this.currentBudgetID) return;

    this.budgetReassignmentService.EditReview(`api/BudgetAssignment/GetBudgetReassignmentHistory?currentBudgetId=${this.currentBudgetID}`)
      .subscribe({
        next: (res: any) => {
          if (res?.Status === 0 && res?.Data) {
            this.rowData = res.Data;
          }
        },
        error: err => {
          console.error('Error loading budget data:', err);
        }
      });
  }

  validation(): boolean {
    const {
      budgetType,
      amount: amountRaw,
      targetBudgetId
    } = this.budgetReAssignmentForm.value;

    const unusedAmountRaw = this.budgetReAssignmentForm.get('unusedAmount')?.value;

    let isValid = true;
    const messages: string[] = [];

    const highlight = (id: string) => {
      $(`#${id}`).addClass('ng-touched ng-invalid validate-error');
      $(`#${id}`).removeClass('ng-valid');
    };

    const clearHighlight = (id: string) => {
      $(`#${id}`).removeClass('ng-touched ng-invalid validate-error');
      $(`#${id}`).addClass('ng-valid');
    };

    // Convert amount and unusedAmount safely
    const amount = Number(amountRaw);
    const unusedAmount = Number(unusedAmountRaw);

    // Budget Type validation
    if (!budgetType) {
      highlight('budgetType');
      messages.push('Please select Budget Type.');
      isValid = false;
    } else {
      clearHighlight('budgetType');
    }
    // Target Budget validation
    if ((budgetType === 1 || budgetType === 2) && !targetBudgetId) {
      highlight('targetBudgetId');

      if (budgetType === 1) {
        messages.push('Please select "Carry Forward To: Budget".');
      } else if (budgetType === 2) {
        messages.push('Please select "Reallocation From: Budget".');
      }

      isValid = false;
    } else {
      clearHighlight('targetBudgetId');
    }

    // Amount validation (common to both types)
    if (amountRaw == null || amountRaw === '' || isNaN(amount)) {
      highlight('amount');
      messages.push('Please enter a valid amount.');
      isValid = false;
    } else if (amount <= 0) {
      highlight('amount');
      messages.push('Amount should be greater than 0.');
      isValid = false;
    } else if (budgetType === 1 && amount > unusedAmount) {
      highlight('amount');
      messages.push('For Budget Surplus, amount cannot exceed unused amount.');
      isValid = false;
    } else if (budgetType === 2 && amount > unusedAmount) {
      highlight('amount');
      messages.push('Amount cannot exceed unused amount for the selected budget.');
      isValid = false;
    } else {
      clearHighlight('amount');
    }

    // Show validation errors
    if (!isValid) {
      this.commonService.ValidationBanner(messages.join('<br/>'));
    }

    return isValid;
  }

  save() {
    if (!this.validation()) {
      return;
    }

    const data = {
      budgetType: this.budgetReAssignmentForm.get('budgetType')?.value,
      budgetId: this.Content.data.ID,
      budgetTargetId: this.budgetReAssignmentForm.get('targetBudgetId')?.value,
      amount: this.budgetReAssignmentForm.get('amount')?.value,
    };

    console.log(this.budgetReAssignmentForm.getRawValue());
    this.budgetReassignmentService.Insert("api/BudgetAssignment/SaveBudgetReAssignment", data).subscribe(result => {
      if (result.Status == 0) {
        this.commonService.SuccessBanner(result.Message);
        this.modalRef.close(result);
      }
      else {
        this.commonService.ValidationBanner(result.Message);
      }
    });
  }

  preventInvalidInput(event: KeyboardEvent): void {
    const invalidChars = ['e', 'E', '+', '-'];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
      return;
    }

    const allowedKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'
    ];
    if (allowedKeys.includes(event.key)) {
      return; // allow default behavior
    }

    const input = event.target as HTMLInputElement;
    const { value, selectionStart, selectionEnd } = input;

    // Simulate the value if the key is allowed
    const newValue =
      value.substring(0, selectionStart ?? 0) +
      event.key +
      value.substring(selectionEnd ?? 0);

    // Allow numbers with optional one dot and up to 2 decimal places
    //Beacuse In Number(38,2) so 36(Values) and 2(decimal values)
    const decimalRegex = /^\d{0,36}(\.\d{0,2})?$/;

    if (!decimalRegex.test(newValue)) {
      event.preventDefault();
    }
  }

  preventInvalidPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const isInvalid = !/^\d*\.?\d{0,1}$/.test(clipboardData);
    if (isInvalid) {
      event.preventDefault();
    }
  }

  onBudgetTypeChange(value: number): void {
    this.selectedBudgetType = value;

    this.budgetReAssignmentForm.get('targetBudgetId')?.reset();
    this.budgetReAssignmentForm.get('unusedAmount')?.reset();

    if (value === 1) {
      this.budgetReAssignmentForm.get('amount')?.setValue(this.Content.UnusedAmount || 0);
    } else {
      this.budgetReAssignmentForm.get('amount')?.reset();
    }

    this.loadAllBudgetExcludingCurrent();
  }

  onTargetBudgetChange(selectedBudgetId: string): void {
    this.loadAllBudgetExcludingCurrent();
    if (this.selectedBudgetType === 2 && selectedBudgetId) {
      const selected = this.allBudgetsRaw.find((b: any) => b.ID === selectedBudgetId);
      const unused = selected?.ACTUAL_REMAINING_BUDGET ?? 0;

      this.budgetReAssignmentForm.patchValue({
        unusedAmount: unused
      });
    }
  }

  getMatchedBudgetDataFromAPI(id: any): any {
    return this.allBudgetsRaw?.find((b: any) => b.ID === id);
  }


}
